// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__MtOS1","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__6Ivay"};